import { c as _c } from "react/compiler-runtime";
import { Typography, useTheme } from "@mui/material";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import PhoneLink from "@/app/components/PhoneLink/PhoneLink";
import { DigitalVisitReasonEnum } from "@/lib/__generated/api";
import { useSchedulerSelector } from "@/lib/hooks/useSchedulerMachine";
import { dataLayerPush } from "@/lib/utils/dataLayerHelpers";
interface Props {
  phoneNumber: string;
}
export default function NeedAssistance(t0) {
  const $ = _c(16);
  const {
    phoneNumber
  } = t0;
  const globalT = useTranslations("Global");
  const webFacilityDetails = useSchedulerSelector(_temp);
  const reasonForVisit = useSchedulerSelector(_temp2);
  const theme = useTheme();
  let t1;
  let t2;
  if ($[0] !== phoneNumber || $[1] !== reasonForVisit || $[2] !== webFacilityDetails) {
    t1 = () => {
      if (webFacilityDetails) {
        dataLayerPush({
          event: "invoca_page_load",
          brand: reasonForVisit === DigitalVisitReasonEnum.ClearAligners ? "mottoaligners" : "aspendental",
          invoca_phone_number: phoneNumber?.replaceAll(/\D/g, "")?.replaceAll(/^1/g, "")?.replaceAll(/(\d{3})(\d{3})(\d{4})/g, "$1-$2-$3")
        });
      }
    };
    t2 = [webFacilityDetails, reasonForVisit, phoneNumber];
    $[0] = phoneNumber;
    $[1] = reasonForVisit;
    $[2] = webFacilityDetails;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      textAlign: "center"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== globalT) {
    t4 = globalT("assistance");
    $[6] = globalT;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== theme.palette.text.secondary) {
    t5 = {
      marginLeft: ".25rem",
      color: theme.palette.text.secondary
    };
    $[8] = theme.palette.text.secondary;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== phoneNumber || $[11] !== t5) {
    t6 = <PhoneLink phoneNumber={phoneNumber} sx={t5} />;
    $[10] = phoneNumber;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <Typography id="need-assistance-contact" variant="bodyM" sx={t3}>{t4}{t6}</Typography>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp2(s_0) {
  return s_0.context.reasonForVisit;
}
function _temp(s) {
  return s.context.facility;
}